import { render } from "../templates/scenario-product-tree-actions.html?vue&type=template&id=51cc80f4"
import script from "./scenario-product-tree-actions.vue?vue&type=script&lang=js"
export * from "./scenario-product-tree-actions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__